import { DebugPanel } from '@design/components/debug-panel/DebugPanel'
import { Error404Screen } from '@design/components/screens/error-404-screen/Error404Screen'
import { Toaster } from '@design/ui/sonner'
import { ROUTES } from '@discover/utils/router/paths'
import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

export interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />

      <Toaster />
      {import.meta.env.MODE === 'dev' && <DebugPanel />}
    </>
  ),
  notFoundComponent: () => <Error404Screen rootUrl={ROUTES.root} />,
})
